import React from 'react';
import {
	BookmarksSVG,
	CollectionsSVG,
	CompassSVG,
	MapSVG,
} from './icons/TabSVGs';
import CustomTabBtn from './CustomTabBtn';
import { TabNav } from './tabStyles';

const CustomTabs: React.FC = () => {
	return (
		<TabNav>
			<CustomTabBtn href="/home">
				<CompassSVG />
			</CustomTabBtn>
			<CustomTabBtn href="/placemap">
				<MapSVG />
			</CustomTabBtn>
			<CustomTabBtn href="/stories">
				<CollectionsSVG />
			</CustomTabBtn>
			<CustomTabBtn href="/bookmarks">
				<BookmarksSVG />
			</CustomTabBtn>
		</TabNav>
	);
};

export default CustomTabs;
